import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-mutual-fund',
  templateUrl: './mobile-mutual-fund.component.html',
  styleUrls: ['./mobile-mutual-fund.component.scss', './../ifacss.scss']
})
export class MobileMutualFundComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
